import { createFileRoute } from '@tanstack/react-router';

import { LessonModePage } from '@/features/teacher/lessonMode/LessonModePage';

export const Route = createFileRoute('/_authed/teacher/lesson')({
  validateSearch: (search): { lesson?: string } => ({
    lesson: typeof search.lesson === 'string' ? search.lesson : undefined,
  }),
  component: LessonModePage,
});
